import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { Divider } from '@mui/material';
import { styled, Box } from '@mui/system';

var Layout = styled(Box, { shouldForwardProp: function (p) { return p !== "mobile"; } })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px dotted ", ";\n  ", "\n  ", "\n  border-radius: 5px;\n  position: relative;\n"], ["\n  border: 1px dotted ", ";\n  ", "\n  ", "\n  border-radius: 5px;\n  position: relative;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral600;
}, function (_a) {
    var mobile = _a.mobile;
    return mobile && "border: none;";
}, function (_a) {
    var label = _a.label;
    return label && "border-top: none;";
});
var TopDivider = styled(Divider)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  text-align: center;\n  left: 0;\n  right: 0;\n  top: 0;\n  padding: 0 2px;\n  transform: translateY(-50%);\n\n  &:before,\n  &:after {\n    border-color: ", ";\n    border-top-style: dotted;\n  }\n"], ["\n  position: absolute;\n  text-align: center;\n  left: 0;\n  right: 0;\n  top: 0;\n  padding: 0 2px;\n  transform: translateY(-50%);\n\n  &:before,\n  &:after {\n    border-color: ", ";\n    border-top-style: dotted;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral600;
});
var DropdownItem = styled(Box, {
    shouldForwardProp: function (p) { return p !== "active"; },
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
    var active = _a.active, theme = _a.theme;
    return (active ? theme.palette.neutral800 : "inherit");
});
var FilterDropdownWrapper = styled(Box, { shouldForwardProp: function (p) { return p !== "mobile"; } })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n\n  > div > div {\n    padding: ", ";\n  }\n\n  hr {\n    margin: 10px 0;\n  }\n"], ["\n  display: flex;\n\n  > div > div {\n    padding: ", ";\n  }\n\n  hr {\n    margin: 10px 0;\n  }\n"])), function (_a) {
    var mobile = _a.mobile;
    return (mobile ? 0 : "10px 20px");
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { DropdownItem, FilterDropdownWrapper, Layout, TopDivider };
